<div class="section-container">
    <div class="section-title">
        <mat-icon>notes</mat-icon>
        <span>Informações complementares</span>
    </div>

    <div class="row g-2">
        <div class="col-12">
            <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>Informações complementares</mat-label>
                <app-observacao-editor
                    #obsEditor
                    [formControl]="control"
                    placeholder="Texto da observação que será impresso no documento fiscal..."
                    [variaveis]="variaveis"
                    [rows]="4">
                </app-observacao-editor>
            </mat-form-field>
        </div>

        <div class="col-12 variaveis-trigger-row">
            <span class="variaveis-link-inline" role="button"
                [class.variaveis-link-disabled]="variaveis.length === 0"
                [attr.aria-disabled]="variaveis.length === 0"
                [attr.title]="variaveis.length === 0
                    ? (isClassificacaoInformada
                        ? 'Nenhuma variável disponível para o CST e o cClassTrib selecionados.'
                        : 'Selecione o CST e o cClassTrib para exibir as variáveis disponíveis.')
                    : null"
                (mousedown)="obsEditor.saveSelection(); $event.preventDefault()" (click)="onClicarVariaveis(obsEditor)">
                <mat-icon>data_object</mat-icon>
                Exibir variáveis disponíveis
            </span>
        </div>
    </div>
</div>
